<nb-card>
	<nb-card-header class="header">{{ pricingYear | yearDisplay | async }}</nb-card-header>

	<nb-card-body>
		<div class="audit-pricing">
			@for (auditPricing of annualPricing.auditPricings; track auditPricing.type) {
				<div class="price-box">
					<div>
						<div class="audit-type">
							<label id="audit-type-{{pricingYear}}">{{ auditPricing.type | auditType | async }}</label>
						</div>
						<div class="price">
							<span display-in-one-line id="audit-price-{{pricingYear}}">{{ auditPricing.price | price | async }}</span>
						</div>
					</div>
					<div class="audit-onsite-days">
						<div>
							<label>{{ 'pricing-details.audit-days.onsite' | translate }}</label>
						</div>
						<div>
							<span>{{ auditPricing.onsiteDays | number }}</span>
						</div>
					</div>
					<div class="audit-onsite-days">
						<div>
							<label>{{ 'pricing-details.audit-days.offsite' | translate }}</label>
						</div>
						<div>
							<span>{{ auditPricing.offsiteDays | number }}</span>
						</div>
					</div>
				</div>

				@for (fee of feesForAuditType(auditPricing.type); track fee.type) {
					<div class="price-box fee">
						<div>
							<div class="fee-label">
								<span display-in-one-line>{{ ('pricing-details.fees.' + fee.type.toLowerCase()) | translate }}</span>
							</div>
							<div class="price">
								<span display-in-one-line>{{ fee.amount | price | async }}</span>
							</div>
						</div>
					</div>
				}
			}

			<div class="total-price-box">
				<div class="total-price" [ngClass]="{ 'first-year': pricingYear === 0 }">
					<span id="total-year-price-{{pricingYear}}">{{ totalPrice() | price | async }}</span>
				</div>
			</div>
		</div>
	</nb-card-body>
</nb-card>
